export default {
  paymentContainer: {
    padding: 10,
    margin: 10,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  slider: {
    flex: 1,
  },
  tableContainer: {
    flex: 1,
  },
  upgrade: {
    marginLeft: 20,
  },
};



// WEBPACK FOOTER //
// ./src/components/Settings/styles.js